<template>
    <div class="page-web-content">
        <img src="https://p0.ssl.qhimg.com/t11b673bcd6695c31cff9762417.png" alt="" class="toSignup"
            @click="toPosition(0)" draggable="false" />
        <div class="content-module">
            <div class="module-item" style="width: 1120px;">
                <div class="item-title">关于ISC.AI 2026</div>
                <div class="item-introduceText">
                    ISC.AI大会作为全球规格最高、规模最大、影响力最深远的“AI+安全”盛会之一，历经十三年积淀，已汇聚超700场技术交锋、5000+行业里程碑议题，吸引全球30多个国家的2000余位政要、行业领袖、专家学者深度参与。
                </div>
                <div class="item-introduceText">
                    2026年，我们正式步入“智能体规模化应用元年”。智衍万物，安全共生——ISC.AI
                    2026将聚焦AI从“大模型”向“智能体”演进过程中的技术突破、安全挑战与产业重塑，致力于成为全球智能体时代的技术风向标与安全守门人。
                </div>
            </div>
            <div class="module-item" style="width: 1120px; margin-top: 20px;">
                <div class="item-title">你的声音，值得被世界听见</div>
                <div class="item-introduceText">
                    在ISC.AI的舞台上，每一个议题都不只是一次演讲，而是一次影响行业的机会。过去十三年，这里见证了5000+议题如何从思想变为现实，如何从技术圈层走向产业落地。2026年，我们邀请你加入这场定义未来的对话。
                </div>
            </div>
            <div class="module-item" style="margin-top: -20px;">
                <div class="item-title-icon">
                    <img class="icon" src="https://p1.ssl.qhimg.com/t110b9a9301f95ba35d314931b2.png" alt="">
                    <div class="title">四大价值</div>
                </div>
                <div class="item-content">
                    <img class="content-img" style="width: 1328px;"
                        src="https://s2.ssl.qhres2.com/static/a730f4e45dadc28f.svg" alt="">
                </div>
            </div>
            <div class="module-item">
                <div class="item-title-icon">
                    <img class="icon" src="https://p5.ssl.qhimg.com/t110b9a9301c27e0893c4c45d93.png" alt="">
                    <div class="title">入围演讲人专属权益</div>
                </div>
                <div class="item-content">
                    <img class="content-img" style="width: 928px;"
                        src="https://s3.ssl.qhres2.com/static/676b65a00ce98e57.svg" alt="">
                </div>
            </div>
            <div class="module-item">
                <div class="item-title-icon">
                    <img class="icon" src="https://p4.ssl.qhimg.com/t110b9a930193126086916c82a6.png" alt="">
                    <div class="title">议题方向</div>
                </div>
                <div class="item-content">
                    <div class="content-nr">
                        <div class="nr-desc">无论你是技术专家、企业决策者，还是高校学者、创业先锋，只要你的观点有深度、实践有价值，这里都有属于你的舞台。</div>
                        <div class="nr-box">
                            <div class="box-box">
                                <div class="box-top">
                                    <img src="https://p5.ssl.qhimg.com/t110b9a930153f347bb340bc9e9.png" class="top-logo"
                                        alt="" />
                                    <div class="top-title">AI技术与应用</div>
                                </div>
                                <div class="box-bottom">
                                    <div class="bottom-direction">
                                        <div class="direction-title">创新技术</div>
                                        <div class="direction-text">· 大模型技术：多模态模型、Transformer架构、向量数据库、推理优化、LLMOps / MLOps等</div>
                                        <div class="direction-text">· 智能体技术：Agent架构设计、Agent开发框架、Agent平台、Agent能力进化（自助决策、自主学习等）、Skills与工具生态、MCP与标准化等</div>
                                        <div class="direction-text">· 具身智能技术：多模态感知、空间理解、决策与控制、仿真与训练等</div>
                                    </div>
                                    <div class="bottom-direction">
                                        <div class="direction-title">行业应用</div>
                                        <div class="direction-text">· 企业级AI应用：企业知识库、Agent驱动自动化、智能客服、智能助手等</div>
                                        <div class="direction-text">· 垂直行业AI应用：金融、医疗、教育、制造、政务等行业落地实践</div>
                                        <div class="direction-text" style="margin-top: 184px;">【包括但不限于以上议题方向】</div>
                                    </div>
                                </div>
                            </div>
                            <div class="box-box" style="margin-left: 80px;">
                                <div class="box-top">
                                    <img src="https://p5.ssl.qhimg.com/t110b9a930153f347bb340bc9e9.png" class="top-logo"
                                        alt="" />
                                    <div class="top-title">AI安全与创新</div>
                                </div>
                                <div class="box-bottom">
                                    <div class="bottom-direction">
                                        <div class="direction-title">AI自身安全</div>
                                        <div class="direction-text">· 模型层安全：对抗攻击防御、模型窃取防护、模型安全对齐等</div>
                                        <div class="direction-text">· 数据层安全：数据投毒防御、数据隐私保护等</div>
                                        <div class="direction-text">· 应用层安全：Agent安全、MCP安全、RAG安全、越狱攻击防御等</div>
                                        <div class="direction-text">· AI治理与合规：风险管理、可解释性、AI审计与伦理等</div>
                                    </div>
                                    <div class="bottom-direction">
                                        <div class="direction-title">AI赋能安全</div>
                                        <div class="direction-text">· 安全大模型：安全语义理解与分析、威胁检测与分析能力、安全推理与决策等</div>
                                        <div class="direction-text">· 安全智能体：AI SOC、安全Skills、MCP标准化接入、攻防智能体等</div>
                                        <div class="direction-text">· 新型安全威胁与防御：AIGC内容安全、AI反欺诈、深度伪造检测等</div>
                                    </div>
                                    <div class="bottom-direction">
                                        <div class="direction-title">行业应用</div>
                                        <div class="direction-text">· 企业级应用：AI数据泄露、安全运营、终端与网络安全、软件与供应链安全等</div>
                                        <div class="direction-text">· 垂直行业应用：金融、医疗、教育、制造、政务等行业落地实践</div>
                                        <div class="direction-text" style="margin-top: 40px;">【包括但不限于以上议题方向】</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="module-item" style="margin-top: 50px;">
                <div class="item-title">三步完成申报，解锁全球舞台</div>
                <div class="item-content" style="margin: 20px auto 16px">
                    <img class="content-img" style="width: 1020px;"
                        src="https://s5.ssl.qhres2.com/static/4be9c87fcb7eca6f.svg" alt="">
                </div>
            </div>
        </div>
        <div class="content-hot">
            <div class="hot-title">纳米AI智能体推荐热门议题</div>
            <div class="hot-tishi">
                点一下议题试试<img src="https://p1.ssl.qhimg.com/t110b9a93016ae6a9f36c0a7f75.png" alt="">
            </div>
            <div class="hot-content">
                <hotsVue v-if="showHots" :list="topicListFormat"></hotsVue>
            </div>
            <img class="hot-update" @click="getTopicList()"
                src="https://p4.ssl.qhimg.com/t110b9a93014ad74581bdbdf92b.png" alt="">
        </div>
        <div class="content-join" id="topicJoin">
            <div class="join-title">{{ showType == 1 ? '我要讲 议题报名' : showType == 2 ? '我要听 议题报名' : '议题报名' }}</div>
            <div class="join-button">
                <div :class="[showType == 1 ? 'active' : '', 'btn-speak']" @click="toPosition(1)">
                    <img src="https://p2.ssl.qhimg.com/t110b9a9301659806f4d5fd3d24.png" alt="" />
                    <span>我要讲</span>
                </div>
                <div :class="[showType == 2 ? 'active' : '', 'btn-listen']" @click="toPosition(2)">
                    <img src="https://p1.ssl.qhimg.com/t110b9a9301fe179164e636f275.png" alt="" />
                    <span>我要听</span>
                </div>
            </div>
            <div class="join-box">
                <speakFormsVue v-if="showType == 1"></speakFormsVue>
                <listenFormsVue v-if="showType == 2"></listenFormsVue>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
// import rulesVue from '../components/rules.vue'
import hotsVue from '../components/hots.vue'
import speakFormsVue from '../components/speakForms.vue'
import listenFormsVue from '../components/listenForms.vue'
import { topicList } from '@/mock/2026/topic.js';

let topicListFormat = ref([])
let showHots = ref(false)
let showType = ref(0)

onMounted(() => {
    getTopicList()
})

const getTopicList = () => {
    showHots.value = false
    //从topicList中无规则随机获取30个议题
    topicListFormat.value = getRandomTopics(topicList, 30)
    setTimeout(() => {
        showHots.value = true
    }, 100);
}

function getRandomTopics(list, count = 30) {
  const result = []
  const used = new Set()

  while (result.length < count && result.length < list.length) {
    const index = Math.floor(Math.random() * list.length)
    if (!used.has(index)) {
      used.add(index)
      result.push(list[index])
    }
  }
  return result
}

function scrollToElementWithOffset(element, offset = 0) {
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth', // 平滑滚动
    });
}
const toPosition = (id) => {
    if (id == 0) {
        setTimeout(() => {
            scrollToElementWithOffset(document.getElementById('topicJoin'), 80);
        },);
    } else {
        showType.value = id
        setTimeout(() => {
            scrollToElementWithOffset(document.getElementById('topicJoin'), 80);
        },);
    }
}


</script>
<style lang="scss" scoped>
.page-web-content {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 104px 0 200px;

    .content-module {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;

        .module-item {
            display: flex;
            flex-direction: column;
            margin-bottom: 68px;

            .item-title {
                color: rgb(44, 44, 44);
                font-family: Source Han Sans;
                font-size: 36px;
                font-weight: 700;
                line-height: 36px;
                letter-spacing: 0px;
                text-align: center;
                margin-bottom: 32px;
            }

            .item-introduceText {
                color: rgb(44, 44, 44);
                font-family: Source Han Sans;
                font-size: 16px;
                font-weight: 400;
                line-height: 32px;
                letter-spacing: 0px;
                text-align: justify;
                margin-bottom: 16px;
            }

            .item-title-icon {
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                    height: 36px;
                }

                .title {
                    color: rgba(44, 44, 44, 1);
                    font-family: "Source Han Sans CN";
                    font-style: Medium;
                    font-size: 30px;
                    font-weight: 500;
                    line-height: 26px;
                    letter-spacing: 0px;
                    text-align: center;
                    margin-left: 12px;
                }
            }

            .item-content {
                margin-top: 40px;

                .content-nr {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 1328px;
                    border-radius: 12px;
                    box-shadow: 0px 1px 2px 0px rgba(26, 107, 214, 0.25);
                    background: linear-gradient(180.00deg, rgba(217, 239, 255, 1) 0%, rgba(255, 255, 255, 1) 25%);
                    padding: 30px 50px;

                    .nr-desc {
                        color: var(--文字, rgba(44, 44, 44, 1));
                        font-family: "Source Han Sans CN";
                        font-style: Regular;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 32px;
                        letter-spacing: 0px;
                        text-align: center;
                        margin-bottom: 48px;
                    }

                    .nr-box {
                        display: flex;
                        width: 100%;

                        .box-box {
                            width: 100%;
                            display: flex;
                            flex-direction: column;

                            .box-top {
                                display: flex;
                                align-items: center;
                                width: 100%;
                                border-bottom: 1px solid rgba(26, 107, 214, 1);
                                padding-bottom: 20px;

                                .top-icon {
                                    height: 20px;
                                }

                                .top-title {
                                    color: var(--主色调（蓝）, rgba(26, 107, 214, 1));
                                    font-family: "Source Han Sans CN";
                                    font-style: Bold;
                                    font-size: 24px;
                                    font-weight: 700;
                                    line-height: 20px;
                                    letter-spacing: 0px;
                                    margin-left: 12px;
                                }
                            }

                            .box-bottom {
                                display: flex;
                                flex-direction: column;
                                margin-top: 16px;
                                .bottom-direction {
                                    display: flex;
                                    flex-direction: column;

                                    .direction-title {
                                        color: var(--文字, rgba(44, 44, 44, 1));
                                        font-family: "Source Han Sans CN";
                                        font-style: Bold;
                                        font-size: 18px;
                                        font-weight: 700;
                                        line-height: 24px;
                                        letter-spacing: 0px;
                                        margin-top: 16px;
                                        margin-bottom: 16px;
                                    }

                                    .direction-text {
                                        color: rgba(44, 44, 44, 1);
                                        font-family: "Source Han Sans CN";
                                        font-style: Regular;
                                        font-size: 16px;
                                        font-weight: 400;
                                        line-height: 28px;
                                        letter-spacing: 0px;
                                        text-align: justify;
                                        margin-bottom: 8px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .content-hot {
        width: 100%;
        padding: 54px 0 63px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: rgb(255, 255, 255);

        .hot-title {
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 36px;
            font-weight: 700;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            margin-bottom: 10px;
        }

        .hot-tishi {
            display: flex;
            align-items: center;
            color: rgb(105, 100, 100);
            font-family: Outfit;
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0px;
            text-align: center;
            text-transform: uppercase;
            margin-bottom: 32px;

            img {
                width: 20px;
                transform: rotate(180deg);
                margin-left: 2px;
            }
        }

        .hot-content {
            width: 100%;
            height: 440px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .hot-update {
            cursor: pointer;
            height: 24px;
            margin-top: 20px;
        }
    }

    .content-join {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 78px;

        .join-title {
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 36px;
            font-weight: 700;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            margin-bottom: 36px;
        }

        .join-subtitle {
            color: rgb(177, 176, 176);
            font-family: Outfit;
            font-size: 16px;
            font-weight: 300;
            line-height: 18px;
            letter-spacing: 0px;
            text-align: center;
            text-transform: uppercase;
            margin-bottom: 59px;
        }

        .join-button {
            display: flex;
            align-items: center;
            margin-bottom: 36px;

            .btn-speak {
                cursor: pointer;
                width: 200px;
                height: 60px;
                box-sizing: border-box;
                border-right: 1px solid rgba(255, 255, 255, 0.15);
                border-radius: 32px 0px 0px 32px;
                background: linear-gradient(180.00deg, rgb(95, 115, 164), rgb(9, 32, 88) 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0.9;

                img {
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                }

                span {
                    color: rgb(255, 255, 255);
                    font-family: Source Han Sans;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                }

                &:hover {
                    opacity: 1;
                }

                &.active {
                    opacity: 1;
                }
            }

            .btn-listen {
                cursor: pointer;
                width: 200px;
                height: 60px;
                box-sizing: border-box;
                border-left: 1px solid rgba(0, 0, 0, 0.5);
                border-radius: 0px 32px 32px 0px;
                background: linear-gradient(180.00deg, rgb(95, 115, 164), rgb(9, 32, 88) 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0.9;

                img {
                    width: 32px;
                    height: 32px;
                    margin-right: 10px;
                }

                span {
                    color: rgb(255, 255, 255);
                    font-family: Source Han Sans;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                }

                &:hover {
                    opacity: 1;
                }

                &.active {
                    opacity: 1;
                }
            }
        }
    }

    .content-rules {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 104px;

        .rules-title {
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 36px;
            font-weight: 700;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            margin-bottom: 16px;
        }

        .rules-subtitle {
            color: rgb(177, 176, 176);
            font-family: Outfit;
            font-size: 16px;
            font-weight: 300;
            line-height: 18px;
            letter-spacing: 0px;
            text-align: center;
            text-transform: uppercase;
            margin-bottom: 59px;
        }
    }

    .toSignup {
        position: fixed;
        right: 70px;
        top: 60%;
        width: 100px;
        height: 109px;
        z-index: 40;
        cursor: pointer;
    }
}
</style>